import { MapPin, TrendingUp, Activity } from 'lucide-react';

export function CincinnatiAdvantageCard() {
  const recentUpdates = [
    { payer: 'Anthem BCBS Ohio', update: 'Policy update synchronized', time: '2h ago' },
    { payer: 'Ohio BWC', update: 'Fee Schedule 2026 integrated', time: '4h ago' },
    { payer: 'Medical Mutual', update: 'Auth requirements updated', time: '1d ago' },
  ];

  return (
    <div className="glass-card-elevated rounded-xl p-4 md:p-6 border border-border/30">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
            <MapPin className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Cincinnati Advantage</h3>
            <p className="text-xs text-muted-foreground">60+ Years Local Intelligence</p>
          </div>
        </div>
        <div className="flex items-center gap-2 px-2 py-1 rounded-full bg-success/10 border border-success/20">
          <Activity className="h-3 w-3 text-success" />
          <span className="text-xs text-success font-medium">Live</span>
        </div>
      </div>

      <div className="space-y-3">
        {recentUpdates.map((update) => (
          <div 
            key={update.payer}
            className="flex items-center gap-3 p-3 rounded-lg bg-card/50 border border-border/30"
          >
            <div className="w-2 h-2 rounded-full bg-chart-2 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-foreground truncate">{update.payer}</div>
              <div className="text-xs text-muted-foreground truncate">{update.update}</div>
            </div>
            <span className="text-xs text-muted-foreground shrink-0">{update.time}</span>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-border/30">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Ohio Payer Coverage</span>
          <div className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4 text-success" />
            <span className="font-mono text-success">98.5%</span>
          </div>
        </div>
      </div>
    </div>
  );
}
